module.exports = __webpack_public_path__ + "static/media/Trial1_wordchain.4f7d7f0f.mp3";